import { render } from "./SectionReference.vue?vue&type=template&id=37d45a5f&scoped=true"
import script from "./SectionReference.vue?vue&type=script&lang=js"
export * from "./SectionReference.vue?vue&type=script&lang=js"

import "./SectionReference.vue?vue&type=style&index=0&id=37d45a5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d45a5f"]])

export default __exports__